exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".power-up__flexRow__2niHI{display:flex;flex-direction:row}.power-up__flexColumn__3SieL{display:flex;flex-direction:column}.power-up__relative__306mz{position:relative}.power-up__flexRowSpaceBetween__2rNut{display:flex;flex-direction:row;justify-content:space-between}.power-up__flexColumnCenter__DmJIX,.power-up__nameContainer__1N21s{display:flex;flex-direction:column;justify-content:center}.power-up__nameContainer__1N21s{width:100%}.power-up__name__2ogDy{font-size:16px;font-weight:700;line-height:normal;margin-left:8px}.power-up__name__2ogDy.power-up__loadingSkeleton__3YicH{height:18px;margin-bottom:4px;min-width:100px}.power-up__subtitle__3CyyJ{font-size:14px;letter-spacing:-.3px;line-height:normal;margin-left:7px;overflow:hidden;text-overflow:ellipsis;white-space:no-wrap}.power-up__icon__2u-0p{background-position:50%;background-repeat:no-repeat;background-size:cover;border-radius:4px;display:inline-block;text-align:center;height:32px;width:32px}.power-up__description__2693F{font-size:14px;margin-top:8px;line-height:18px;height:54px;overflow:hidden}.power-up__descriptionAtom__3MN0g{background-color:#fff;border-radius:4px;box-shadow:0 1px 3px rgba(0,0,0,.15);padding:10px;height:100px}.power-up__descriptionAtom__3MN0g:hover{background:rgba(0,0,0,.05)}.power-up__featuredAtomContainer__WkF3f{background:#fff;min-width:304px;max-height:368px;border-radius:4px;box-shadow:0 1px 3px rgba(0,0,0,.15)}.power-up__featuredAtom__3pHPd{padding:10px;height:100px}.power-up__heroImage__2JRMH{height:240px;width:100%;border-radius:4px 4px 0 0}@-webkit-keyframes power-up__loadingSkeletonAnimation__398Qv{0%{background-position:-468px 0}to{background-position:468px 0}}@keyframes power-up__loadingSkeletonAnimation__398Qv{0%{background-position:-468px 0}to{background-position:468px 0}}.power-up__loadingSkeleton__3YicH{-webkit-animation-duration:1.5s;animation-duration:1.5s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:linear;animation-timing-function:linear;-webkit-animation-name:power-up__loadingSkeletonAnimation__398Qv;animation-name:power-up__loadingSkeletonAnimation__398Qv;background:linear-gradient(90deg,#ebeef0 8%,#dfe3e6 18%,#ebeef0 33%);background-size:800px 104px}.power-up__loadingSkeletonButton__3dQBX{height:24px;min-width:64px;margin-top:3px;border-radius:3px}", ""]);

// exports
exports.locals = {
	"N0": "#FFFFFF",
	"N10": "#FAFCFC",
	"N20": "#F5F6F7",
	"N30": "#EBEEF0",
	"N40": "#DFE3E6",
	"N50": "#C2CCD1",
	"N60": "#B3BEC4",
	"N70": "#A6B3BA",
	"N80": "#97A7B0",
	"N90": "#899AA3",
	"N100": "#798D99",
	"N200": "#6B808C",
	"N300": "#5E7785",
	"N400": "#516B7A",
	"N500": "#425E6E",
	"N600": "#355263",
	"N700": "#254659",
	"N800": "#17394D",
	"N900": "#092D42",
	"N10A": "rgba(9, 45, 66, 0.02)",
	"N20A": "rgba(9, 45, 66, 0.04)",
	"N30A": "rgba(9, 45, 66, 0.08)",
	"N40A": "rgba(9, 45, 66, 0.13)",
	"N50A": "rgba(9, 45, 66, 0.25)",
	"N60A": "rgba(9, 45, 66, 0.31)",
	"N70A": "rgba(9, 45, 66, 0.36)",
	"N80A": "rgba(9, 45, 66, 0.42)",
	"N90A": "rgba(9, 45, 66, 0.48)",
	"N100A": "rgba(9, 45, 66, 0.54)",
	"N200A": "rgba(9, 45, 66, 0.6)",
	"N300A": "rgba(9, 45, 66, 0.66)",
	"N400A": "rgba(9, 45, 66, 0.71)",
	"N500A": "rgba(9, 45, 66, 0.77)",
	"N600A": "rgba(9, 45, 66, 0.82)",
	"N700A": "rgba(9, 45, 66, 0.89)",
	"N800A": "rgba(9, 45, 66, 0.95)",
	"trello-blue-50": "#E4F0F6",
	"trello-blue-100": "#BCD9EA",
	"trello-blue-200": "#8BBDD9",
	"trello-blue-300": "#5BA4CF",
	"trello-blue-400": "#298FCA",
	"trello-blue-500": "#0079BF",
	"trello-blue-600": "#026AA7",
	"trello-blue-700": "#055A8C",
	"trello-blue-800": "#094C72",
	"trello-blue-900": "#0C3953",
	"green-50": "#EEF6EC",
	"green-100": "#D6ECD2",
	"green-200": "#B7DDB0",
	"green-300": "#99D18F",
	"green-400": "#7BC86C",
	"green-500": "#61BD4F",
	"green-600": "#5AAC44",
	"green-700": "#519839",
	"green-800": "#49852E",
	"green-900": "#3F6F21",
	"orange-50": "#FDF4E7",
	"orange-100": "#FCE6C6",
	"orange-200": "#FAD29C",
	"orange-300": "#FDBF69",
	"orange-400": "#FFAF3F",
	"orange-500": "#FF9F1A",
	"orange-600": "#E79217",
	"orange-700": "#CD8313",
	"orange-800": "#B4760F",
	"orange-900": "#96650A",
	"red-50": "#FBEDEB",
	"red-100": "#F5D3CE",
	"red-200": "#EFB3AB",
	"red-300": "#EC9488",
	"red-400": "#EF7564",
	"red-500": "#EB5A46",
	"red-600": "#CF513D",
	"red-700": "#B04632",
	"red-800": "#933B27",
	"red-900": "#6E2F1A",
	"yellow-50": "#FDFAE5",
	"yellow-100": "#FAF3C0",
	"yellow-200": "#F5EA92",
	"yellow-300": "#F3E260",
	"yellow-400": "#F5DD29",
	"yellow-500": "#F2D600",
	"yellow-600": "#E6C60D",
	"yellow-700": "#D9B51C",
	"yellow-800": "#CCA42B",
	"yellow-900": "#BD903C",
	"purple-50": "#F7F0FA",
	"purple-100": "#EDDBF4",
	"purple-200": "#DFC0EB",
	"purple-300": "#D5A6E6",
	"purple-400": "#CD8DE5",
	"purple-500": "#C377E0",
	"purple-600": "#A86CC1",
	"purple-700": "#89609E",
	"purple-800": "#6C547B",
	"purple-900": "#484553",
	"pink-50": "#FEF1F9",
	"pink-100": "#FCDCEF",
	"pink-200": "#F9C2E4",
	"pink-300": "#FFABDF",
	"pink-400": "#FF8ED4",
	"pink-500": "#FF78CB",
	"pink-600": "#E568AF",
	"pink-700": "#C9558F",
	"pink-800": "#AE4270",
	"pink-900": "#8E2D4B",
	"sky-50": "#E4F7FA",
	"sky-100": "#BDECF3",
	"sky-200": "#8FDFEB",
	"sky-300": "#5DD3E5",
	"sky-400": "#29CCE5",
	"sky-500": "#00C2E0",
	"sky-600": "#00AECC",
	"sky-700": "#0098B7",
	"sky-800": "#0082A0",
	"sky-900": "#006988",
	"lime-50": "#ECFBF3",
	"lime-100": "#D3F6E4",
	"lime-200": "#B3F1D0",
	"lime-300": "#90ECC1",
	"lime-400": "#6DECA9",
	"lime-500": "#51E898",
	"lime-600": "#4ED583",
	"lime-700": "#4BBF6B",
	"lime-800": "#49AA54",
	"lime-900": "#459139",
	"business-blue-50": "#EDEFF4",
	"business-blue-100": "#D2D7E5",
	"business-blue-200": "#B2B9D0",
	"business-blue-300": "#838FB5",
	"business-blue-400": "#6170A1",
	"business-blue-500": "#42548E",
	"business-blue-600": "#3E4D80",
	"business-blue-700": "#3A476F",
	"business-blue-900": "#30364C",
	"business-blue-800": "#36405F",
	"blue-500": "#0079BF",
	"black": "#000",
	"black-500": "#4d4d4d",
	"near-black": "#4d4d4d",
	"white": "#FFFFFF",
	"flexRow": "power-up__flexRow__2niHI",
	"flexColumn": "power-up__flexColumn__3SieL",
	"relative": "power-up__relative__306mz",
	"flexRowSpaceBetween": "power-up__flexRowSpaceBetween__2rNut",
	"flexColumnCenter": "power-up__flexColumnCenter__DmJIX",
	"nameContainer": "power-up__nameContainer__1N21s",
	"name": "power-up__name__2ogDy",
	"loadingSkeleton": "power-up__loadingSkeleton__3YicH",
	"subtitle": "power-up__subtitle__3CyyJ",
	"icon": "power-up__icon__2u-0p",
	"description": "power-up__description__2693F",
	"descriptionAtom": "power-up__descriptionAtom__3MN0g",
	"featuredAtomContainer": "power-up__featuredAtomContainer__WkF3f",
	"featuredAtom": "power-up__featuredAtom__3pHPd",
	"heroImage": "power-up__heroImage__2JRMH",
	"loadingSkeletonAnimation": "power-up__loadingSkeletonAnimation__398Qv",
	"loadingSkeletonButton": "power-up__loadingSkeletonButton__3dQBX"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[name]__[local]__[hash:base64:5]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2445/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/common/components/power-up/power-up.less
// module id = jG42
// module chunks = 12